import { createContext, useState } from "react"
import API from "services/api"
// import _ from "lodash"

export const ContactContext = createContext({})

const addresslist = [""]
const emaillist = [""]
const contactlist = {
	name: "",
	phoneNumber: "",
	email: ""
}

const ContactProvider = (props) => {
	const [openContact, setOpenContact] = useState(false)
	const [selectedContact, setSelectedContact] = useState(null)
	const [address, setAddress] = useState(addresslist)
	const [email, setEmail] = useState(emaillist)
	const [arrayContact, setArrayContact] = useState([contactlist])
	const [objCompany, setObjCompany] = useState(null)

	const handleChangeAddress = (index, e) => {
		const updatedFormData = [...address]
		updatedFormData[index] = e.target.value
		setAddress(updatedFormData)
	}

	const addField = () => {
		setAddress([...address, ""])
	}

	const removeField = (index) => {
		const updatedFormData = [...address]
		updatedFormData.splice(index, 1)
		setAddress(updatedFormData)
	}

	// handle Email
	const handleChangeEmail = (index, e) => {
		const updatedFormData = [...email]
		updatedFormData[index] = e.target.value
		setEmail(updatedFormData)
	}

	const addFieldEmail = () => {
		setEmail([...email, ""])
	}

	const removeFieldEmail = (index) => {
		const updatedFormData = [...email]
		updatedFormData.splice(index, 1)
		setEmail(updatedFormData)
	}

	// handle contacts
	const handleChangeContact = (index, e) => {
		const updatedFormData = [...arrayContact]
		updatedFormData[index][e.target.name] = e.target.value
		setArrayContact(updatedFormData)
	}

	const handleChangePhone = (index, e) => {
		const updatedFormData = [...arrayContact]

		updatedFormData[index]["phoneNumber"] = e
		setArrayContact(updatedFormData)
	}

	const addFieldContact = () => {
		setArrayContact([...arrayContact, contactlist])
	}

	const removeFieldContact = (index) => {
		const updatedFormData = [...arrayContact]
		updatedFormData.splice(index, 1)
		setArrayContact(updatedFormData)
	}

	const handleCloseContact = () => {
		setOpenContact(false)
	}

	const resetState = (result) => {
		setEmail(result?.email || [])
		setAddress(result?.addresslist || [])
		setArrayContact(result?.contacts || [])
	}

	return (
		<ContactContext.Provider
			value={{
				openContact,
				setOpenContact,

				selectedContact,
				address,
				email,
				arrayContact,

				setSelectedContact,

				handleChangeAddress,
				addField,
				removeField,

				handleChangeEmail,
				addFieldEmail,
				removeFieldEmail,

				handleChangeContact,
				handleChangePhone,

				addFieldContact,
				removeFieldContact,
				handleCloseContact,

				resetState,

				objCompany,
				setObjCompany
			}}
			{...props}
		/>
	)
}

export default ContactProvider
